<template>
  <div>    
          <div v-show="isHidden">
              <a v-on:click="isHidden = !isHidden" class="listbox-delete">
                  <i aria-hidden="true" class="material-icons">remove_circle</i>
              </a>
          </div>
          <div v-if="!isHidden" class="delete-wrapper" v-click-outside="onClickOutside">
              <div class="confirm-delete-wrapper">
                Confirm Removal?
                <button v-on:click="deleteAdmin" type="submit" class="commitbutton"><i aria-hidden="true" class="material-icons align-middle text-xl">delete</i></button>
              </div>
          </div>
        
  </div>
</template>

<script>
import axios from 'axios'
import vClickOutside from 'v-click-outside'

  export default {

        props: {
            value: '',
            route:''
        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
          }
        },
        directives: {
          clickOutside: vClickOutside.directive
        },
        methods: {
          onClickOutside (event) {
              this.isHidden = !this.isHidden
              // console.log('Clicked outside. Event: ', event)
          },
          deleteAdmin: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.put(this.route,
                {
                    admin: '0'
                }
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      };
</script>
